import React from 'react';
import {Create, Datagrid, Edit, List, required, SimpleForm, TextField, TextInput, Filter, AutocompleteInput, ReferenceInput} from 'react-admin';
import exporterCommon from "../import/exporterCommon";
import DefaultListActions, {Empty} from "./common";


const DepartmentFilter = (props) => (
    <Filter {...props}>
        <ReferenceInput perPage={1000} label="Department Name" emptyText="All Departments" allowEmpty source="id" reference="departments" alwaysOn >
            <AutocompleteInput 
                allowEmpty={true} 
                optionText={(record) => record && record.name ? record.name : 'Unnamed Department'} 
                options={{ type: 'search' }} 
            />
        </ReferenceInput >
        {/* Add ReferenceInput + AutocompleteInput here for related fields if needed */}
    </Filter>
)

export const DepartmentList= props => (
    <List  empty={<Empty />}  exporter={exporterCommon(props.resource)} actions={<DefaultListActions/>} {...props} filters={<DepartmentFilter />} >
        <Datagrid rowClick="edit">
            {/*<TextField source="id" />*/}
            <TextField 
                source="name" 
                render={(record) => record && record.name ? record.name : 'Unnamed Department'} 
            />
        </Datagrid>
    </List>
);

export const DepartmentEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="name" validate={[required()]} />
        </SimpleForm>
    </Edit>
);

export const DepartmentCreate = props => (
    <Create {...props}  >
        <SimpleForm redirect='list' >
            <TextInput source="name" validate={[required()]} />
        </SimpleForm>
    </Create>
);
